import { useState, useMemo } from 'react';
import type { OrganizationClientsBase } from './useOrganizationClients';

export function useClientTableData({ clientsForTable, unsyncedDocs }: OrganizationClientsBase) {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredClients = useMemo(() => {
    if (!clientsForTable) return undefined;
    if (!searchQuery.trim()) return clientsForTable;
    const query = searchQuery.toLowerCase();
    return clientsForTable.filter(c =>
      c.person.displayName.toLowerCase().includes(query)
    );
  }, [clientsForTable, searchQuery]);

  const unsyncedClientIds = useMemo(() => {
    if (!unsyncedDocs) return new Set<number>();
    return new Set(unsyncedDocs.map(d => d.client_id));
  }, [unsyncedDocs]);

  return {
    searchQuery,
    setSearchQuery,
    filteredClients,
    unsyncedClientIds,
  };
}
